import { useCallback, useRef, useState } from 'react'
import { HOVER_OTHERS_DIMMING_TIMEOUT } from '@/lib/config'

export default function useHoverOthers() {
  // Handle hover state
  const [hoveredElement, setHoveredElement] = useState<string | null>(null)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const handleMouseEnter = useCallback((element: string) => {
    setHoveredElement(element)

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }

    timeoutRef.current = setTimeout(() => {
      setHoveredElement(null)
    }, HOVER_OTHERS_DIMMING_TIMEOUT)
  }, [])

  const handleMouseLeave = useCallback(() => {
    setHoveredElement(null)
  }, [])

  const isHoveringOther = useCallback(
    (element: string) => {
      return hoveredElement !== null && hoveredElement !== element
    },
    [hoveredElement]
  )

  return {
    hoveredElement,
    handleMouseEnter,
    handleMouseLeave,
    isHoveringOther,
  }
}
